import { useQuery } from "@tanstack/react-query";

import { getDuplicates, getDuplicateCount } from "./fetch";
import { duplicateKeys } from "./keys";


export const useGetDuplicates = ({ onSuccess, onError } = {}) => {
  return useQuery({
    queryKey: duplicateKeys.getDuplicates(),
    queryFn: getDuplicates,
    onSuccess,
    onError,
    refetchOnMount: "always",
  });
};

export const useGetDuplicateCount = () => {
  return useQuery({
    queryKey: duplicateKeys.getDuplicateCount(),
    queryFn: getDuplicateCount,
    refetchOnMount: "always",
  });
};